import React from 'react';
import HRFilterBar, { FilterSelect } from './HRFilterBar';
import {
  TEAM_AVAILABILITY_OPTIONS, LICENSE_CATEGORIES, SALARY_BANDS,
  DEFAULT_TEAM_FILTERS, DEFAULT_RECRUIT_FILTERS, isFilterActive,
} from '../../utils/hrFilters';

const LEVELS = (t) => [{ id: 'all', label: t('hr_filter_all') }, ...[1, 2, 3, 4, 5].map((l) => ({ id: String(l), label: `${t('hr_filter_level_short')} ${l}` }))];

/** RH → Équipe : permis / niveau / disponibilité. */
export function TeamFilters({ t, filters, onChange, shown, total }) {
  const set = (k) => (v) => onChange({ ...filters, [k]: v });
  return (
    <HRFilterBar t={t} shown={shown} total={total} active={isFilterActive(filters, DEFAULT_TEAM_FILTERS)} onReset={() => onChange(DEFAULT_TEAM_FILTERS)} testId="team-filters">
      <FilterSelect label={t('hr_filter_license')} value={filters.license} onChange={set('license')} testId="team-filter-license"
        options={[{ id: 'all', label: t('hr_filter_all') }, ...LICENSE_CATEGORIES.map((l) => ({ id: l, label: l }))]} />
      <FilterSelect label={t('hr_filter_level')} value={filters.level} onChange={set('level')} testId="team-filter-level" options={LEVELS(t)} />
      <FilterSelect label={t('hr_filter_availability')} value={filters.availability} onChange={set('availability')} testId="team-filter-availability"
        options={TEAM_AVAILABILITY_OPTIONS.map((o) => ({ id: o.id, label: t(o.labelKey) }))} />
    </HRFilterBar>
  );
}

/** RH → Recrutement : coût employeur / niveau / spécialité. */
export function RecruitFilters({ t, filters, onChange, specialties, shown, total }) {
  const set = (k) => (v) => onChange({ ...filters, [k]: v });
  return (
    <HRFilterBar t={t} shown={shown} total={total} active={isFilterActive(filters, DEFAULT_RECRUIT_FILTERS)} onReset={() => onChange(DEFAULT_RECRUIT_FILTERS)} testId="recruit-filters">
      <FilterSelect label={t('hr_filter_salary')} value={filters.salary} onChange={set('salary')} testId="recruit-filter-salary"
        options={SALARY_BANDS.map((b) => ({ id: b.id, label: b.labelKey ? t(b.labelKey) : b.label }))} />
      <FilterSelect label={t('hr_filter_level')} value={filters.level} onChange={set('level')} testId="recruit-filter-level" options={LEVELS(t)} />
      <FilterSelect label={t('hr_filter_specialty')} value={filters.specialty} onChange={set('specialty')} testId="recruit-filter-specialty"
        options={[{ id: 'all', label: t('hr_filter_all') }, ...specialties.map((s) => ({ id: s, label: s }))]} />
    </HRFilterBar>
  );
}
